const cheeseSpritesheet = {
  "name": "cheeseSpritesheet",
  "tileHeight": 64,
  "tileWidth": 64,
  "spacing": 0,
  "tileCount": 16,
  "columns": 8,
  "spritesheet": "./assets/spritesheets/cheeseSpritesheet.png",
  "sprites": {
    "regularCheese": [0],
    "goldenCheese": [1],
    "radicalCheese": [2],
    "fireyCheese": [3],
    "epicCheese": [4],
    "pizzaCheese": [5],
    "squirrelCheese": [6],
    "wisdomCheese": [7],
    "icyCheese": [8],
    "hairyCheese": [9],
    "diceyCheese": [10]
  }
}
export default cheeseSpritesheet;
